import { Check } from 'lucide-react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function MobileLineEndpointControls({ position, length, value, onChange, onConfirm, directionReady }: {
  position: [number, number];
  length: number;
  value: string;
  onChange: (value: string) => void;
  onConfirm: () => void;
  directionReady: boolean;
}) {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const validTyped = value === '' || (Number.isFinite(Number(value)) && Number(value) > 0);
  const displayed = value !== '' && validTyped ? Number(value) : length;
  const beginEdit = () => {
    if (value === '') onChange(String(Math.round(length * 10) / 10));
    setEditing(true);
    window.setTimeout(() => { inputRef.current?.focus(); inputRef.current?.select(); }, 0);
  };
  return <div className="mobile-line-endpoint" style={{ left: position[0], top: position[1] }} onPointerDown={(event) => event.stopPropagation()}>
    {editing ? <input ref={inputRef} aria-label={`${t('line.length')} (mm)`} type="number" inputMode="decimal" min="0.001" step="any" value={value} onChange={(event) => onChange(event.target.value)} onKeyDown={(event) => {
      event.stopPropagation();
      if (event.key === 'Enter') { event.preventDefault(); inputRef.current?.blur(); setEditing(false); }
    }} /> : <button type="button" className="mobile-line-measure" aria-label={`${t('line.length')} (mm)`} onClick={beginEdit}>{Math.round(displayed * 10) / 10} mm</button>}
    <button type="button" className="mobile-line-confirm" aria-label={t('line.create')} title={t('line.create')} disabled={!directionReady || !validTyped} onClick={onConfirm}><Check size={18} strokeWidth={3} /></button>
  </div>;
}
